import  {ActionTypes}  from "../constants/ActionTypes";
const intialState =[];
export const AddressReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.GET_ADDRESS:
          return payload;
        default:
            return state;
    }
}